import { inject } from 'vue';
import Mustache from 'mustache';

export default function useRenderLiquid({ liquidRenderingEnabled = false, modelValue = {} } = {}) {
  const $bct = inject('translator');

  function renderText(text) {
    if (!text) return '';

    const sanitizedText = replaceLiquidSyntax(text);
    const liquidPlaceholders = getLiquidPlaceholders(sanitizedText);
    const translatedValue = $bct(sanitizedText);

    if (!liquidPlaceholders.length || !isLiquidValue(translatedValue)) return translatedValue;

    return renderLiquidValue(translatedValue, liquidPlaceholders);
  }

  function isLiquidValue(value) {
    if (!value) return false;

    return value.includes('-%');
  }

  function renderLiquidValue(value, liquidPlaceholders) {
    if (!liquidRenderingEnabled) return restoreLiquidSyntax(value, liquidPlaceholders);

    return Mustache.render(value, modelValue, {}, ['-%', '%-']).replace('&#39;', "'");
  }

  function replaceLiquidSyntax(text) {
    return text.replace(/{{/g, '-%').replace(/}}/g, '%-');
  }

  function restoreLiquidSyntax(text, liquidPlaceholders) {
    return liquidPlaceholders.reduce(
      (restoredText, liquidPlaceholder) =>
        restoredText.replaceAll(
          liquidPlaceholder,
          liquidPlaceholder.replace('-%', '{{').replace('%-', '}}'),
        ),
      text,
    );
  }

  function getLiquidPlaceholders(text) {
    return text.match(/-%.*?%-/g) || [];
  }

  return {
    renderText,
  };
}
